import axios from 'axios'
// import {getByPaymentMethod} from './filters.js'
import {loaded} from 'vue2-google-maps'
import Vue from 'vue'

// URL and endpoint constants
const API_URL = 'http://neos.docker/api/v2/stations'

const state = {
    data: [],
    selected: {
        station: null,
        place: null,
        show: false,
        ready: false
    },
    filters: {
        campaign: '',
        fuel: '',
        paymentMethod: '',
        service: ''
    },
    filteredStations: {},
    mapOptions: {
        traffic: false
    },
    google: {
        loaded: false
    },
    ready: false
}

const getters = {
    stations: state => {
        return state.data
    },
    filters: state => {
        return state.filters
    },
    filteredStations: state => {
        let array = []

        state.data.forEach(function (station) {
            if (filterByFuel(station, state.filters) && filterByPayment(station, state.filters) && filterByService(station, state.filters) && filterByCampaign(station, state.filters)) {
                array.push(station)
            }
        })

        return array
    },
    stationPaymentMethodes: state => {
        if (state.ready) {
            let paymentMethodes = []
            state.data.forEach(function (station) {
                station.payment_methodes.forEach(function (method) {
                    if (!objectExists(paymentMethodes, method.name)) {
                        paymentMethodes.push(method)
                        //console.log(paymentMethodes)
                    }
                })
            })
            return paymentMethodes
        }

    },
    stationFuels: state => {
        if (state.ready) {
            let fuels = []
            state.data.forEach(function (station) {
                station.fuel.forEach(function (fuel) {
                    if (!objectExists(fuels, fuel.name)) {
                        fuels.push(fuel)
                        //console.log(fuels)
                    }
                })
            })
            return fuels
        }

    },
    stationServices: state => {
        if (state.ready) {
            let services = []
            state.data.forEach(function (station) {
                station.services.forEach(function (service) {
                    if (!objectExists(services, service.name)) {
                        services.push(service)
                        //console.log(services)
                    }
                })
            })
            return services
        }

    },
    stationCampaigns: state => {
        if (state.ready) {
            let campaigns = []
            state.data.forEach(function (station) {
                station.campaigns.forEach(function (campaign) {
                    if (!objectExists(campaigns, campaign.name)) {
                        campaigns.push(campaign)
                        //console.log(campaigns)
                    }
                })
            })
            return campaigns
        }

    },
    selectedStation: state => {
        return state.selected.station
    },
    selectedPlace: state => {
        return state.selected.place
    },
    googleStatus: state => {
        return state.google.loaded
    },
    mapOptions: state => {
        return state.mapOptions
    }
}

const mutations = {
    CLEAR_SEARCH(state) {
        state.selected.show = false
        state.selected.ready = false
        state.selected.station = null
        state.selected.place = null
        state.selected.show = true
        state.selected.ready = true
    },
    SET_STATIONS(state, stations) {
        state.data = stations
        state.ready = true
    },
    SET_SELECTED_STATION(state, id) {
        state.selected.show = false
        state.selected.ready = false
        state.selected.station = state.data.find((station) => station.tid === id)
        state.selected.place = null
        state.selected.show = true
        state.selected.ready = true
    },
    SET_SELECTED_PLACE(state, place) {
        state.selected.show = false
        state.selected.ready = false
        state.selected.station = null
        state.selected.place = place
        state.selected.show = true
        state.selected.ready = true
    },
    SET_FILTERS(state, filters) {
        state.filters = filters
    },
    RESET_FILTERS(state) {
        state.filters = {campaign: '', fuel: '', paymentMethod: '', service: ''}
    },
    FILTER_STATIONS(state) {
        state.filteredStations = []
    },
    SET_GOOGLE_STATUS(state) {
        loaded.then(function (value) {
            state.google.loaded = true
        }, function (reason) {
            state.google.loaded = false
        })
    },
    SET_MAP_OPTIONS(state, options) {
        state.mapOptions = options
    },
    HIDE_STATION_DETAIL(state, station_id) {
        state.selected.show = false
    },
    CLEAR_STATIONS(state) {
        state.data = {}
        state.ready = false
    }
}

const actions = {
    clearSearch: ({commit}) => {
        commit('CLEAR_SEARCH')
    },
    getStations: ({commit}) => {
        axios.get('/api/v2/stations')
            .then(function (response) {
                let stations = response.data
                stations.forEach(function (station) {
                    station.location = {
                        lat: parseFloat(station.location.lat),
                        lng: parseFloat(station.location.lng)
                    }
                    station.payment_methodes.forEach(function (method) {
                        let icon_name = method.display_name.split(' ').join('-').toLowerCase()
                        method.icon_name = icon_name
                    })
                    station.services.forEach(function (service) {
                        let icon_name = service.display_name.split(' ').join('-').toLowerCase()
                        service.icon_name = icon_name
                    })
                })
                commit('SET_STATIONS', response.data)
            })
            .catch(function (error) {
                console.log(error)
            })
    },
    setSelectedStation: ({commit}, station_id) => {
        commit('SET_SELECTED_STATION', station_id)
    },
    setSelectedPlace: ({commit}, place) => {
        commit('SET_SELECTED_PLACE', place)
    },
    setFilters: ({commit}, filters) => {
        commit('SET_FILTERS', filters)
    },
    resetFilters: ({commit}) => {
        commit('RESET_FILTERS')
    },
    filterStations: ({commit}) => {
        commit('FILTER_STATIONS')
    },
    setMapOptions: ({commit}, options) => {
        commit('SET_MAP_OPTIONS', options)
    },
    hideStationDetail: ({commit}) => {
        commit('HIDE_STATION_DETAIL')
    },
    getGoogleStatus: ({commit}) => {
        commit('SET_GOOGLE_STATUS', status)
    }
}

export default {
    state, mutations, getters, actions
}


function objectExists(array, name) {
    return array.some(function (el) {
        return el.name === name;
    })
}

function filterByPayment (station, filter) {
    if (!filter.paymentMethod || objectExists(station.payment_methodes, filter.paymentMethod)) {
        return true
    }
}

function filterByService (station, filter) {
    if (!filter.service || objectExists(station.services, filter.service)) {
        return true
    }
}

function filterByFuel (station, filter) {
    if (!filter.fuel || objectExists(station.fuel, filter.fuel)) {
        return true
    }
}

function filterByCampaign (station, filter) {
    if (!filter.campaign || objectExists(station.campaigns, filter.campaign)) {
        return true
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScript/store/stationStore.js